import React from 'react';
import styled from '@emotion/styled';
import { DATE_HUGE, moment } from '../../../../shared/i18n/date-time/moment';
import { FormattedDateTime } from '../../../../shared/i18n/date-time/FormattedDateTime';

const StyledDateRow = styled.div`
	flex: 1;
	padding-top: 20px;
	padding-left: 20px;
`;

interface IProps {
	bestKnownTimestamp: number;
}

export const DateRow = ({ bestKnownTimestamp }: IProps) => {
	const date = moment.unix(bestKnownTimestamp);

	return (
		<StyledDateRow>
			<FormattedDateTime value={date} format={DATE_HUGE} />
		</StyledDateRow>
	);
};
